import React, {useEffect, useRef, useState} from "react";
import Div from "../../components/common/Div";
import LoadingBox from "../Partials/LoadingBox";
import {useHistory} from "react-router";

export default function Report(props) {

  let reportUrl = window._env_.REACT_REPORT_URL;
  if (reportUrl === undefined) {
    reportUrl = process.env.REACT_APP_REPORT_URL;

  }

  const history = useHistory();
  const iframeRef = useRef(null);

  if (props === undefined || props.user === undefined) history.push("/login");
  const user = props.user;
  const [isLoading, setIsLoading] = useState(true);

  function getRandURL() {
    return reportUrl + "/student/reportwebview/".concat(user.token);
  }

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.onload = () => {
        setIsLoading(false);
        const iframeDocument =
          iframe.contentDocument || iframe.contentWindow.document;
        iframeDocument.body.style.backgroundColor = "#FBCD02";
      };
    }
  }, [isLoading]);


  return (
    <Div
      maxWidth={"100%"}
      height={"700px"}
      backgroundColor={"#212A41"}
      borderRadius={"5px"}
      padding={"20px"}
      marginTop={"20px"}
    >
      <iframe
        ref={iframeRef}
        src={getRandURL()}
        width="100%"
        height="100%"
        style={{ marginLeft: "0px", borderRadius: "5px", border: "none" }}
        onLoad={() => {
          setIsLoading(false);
        }}
      />
      <LoadingBox display={isLoading} />
    </Div>
  );
}
